import { Fragment, ReactElement } from 'react';

import { DynamicPdfComponentName } from '@breathelife/types';
import { PdfPaddedGrid } from '@breathelife/ui-components';
import { RenderingField } from '@zinnia/form-engine-sdk';

import usePdfContext from '../../../Context/usePdfContext';
import getComponentSettings from '../../../helpers/getComponentSettings';
import { FieldFactory } from '../FieldFactory';

type Props = {
  fields: RenderingField[];
};

export function FieldWrapperA(props: Props): ReactElement | null {
  const { fields } = props;

  const { componentSelection = [] } = usePdfContext();

  const questionnaireSettings = getComponentSettings(componentSelection, DynamicPdfComponentName.Questionnaire);
  const { alignFieldsTop } = questionnaireSettings;

  return (
    <Fragment>
      <PdfPaddedGrid container spacing={3} alignItems={alignFieldsTop ? 'flex-start' : 'flex-end'}>
        {fields.map((field: RenderingField) => (
          <Fragment key={field.id}>
            <FieldFactory field={field} />
          </Fragment>
        ))}
      </PdfPaddedGrid>
    </Fragment>
  );
}
